import { Grid, Text } from '@mantine/core';
import { PaymentStatusResult } from '@bariendo/lib/payment-status';
import { PaymentStatusBadge } from '@/components/PaymentStatusBadge';
import { ORBIT_GRAY } from '@/theme/colors';

/**
 * The payment status as a badge, first in the money group on every track, with the payor after it
 * on employer and insurance: `Ready to schedule · Carrum`. Self-pay shows it too, because a $0
 * balance does not say whether the procedure is booked.
 */
export function PaymentRow({ status }: { status: PaymentStatusResult }) {
  return (
    <Grid align="flex-start" style={{ width: '100%' }}>
      <Grid.Col span={3}>
        <Text style={{ fontSize: 13, lineHeight: '16px', color: ORBIT_GRAY }}>Payment</Text>
      </Grid.Col>
      <Grid.Col span={9}>
        <Text component="div" style={{ fontSize: 14, lineHeight: '20px' }}>
          <PaymentStatusBadge status={status.status} />
          {status.payor && ` · ${status.payor}`}
        </Text>
      </Grid.Col>
    </Grid>
  );
}
